import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { TranslationProvider } from './contexts/TranslationContext'
import { ThemeProvider } from './contexts/ThemeContext'
import { PaletteProvider } from './contexts/PaletteContext'
import { TorchVideoProvider } from './contexts/TorchVideoContext'
import { Analytics } from '@vercel/analytics/react'
import App from './App.jsx'
import en from './translations/en.json'
import './index.css'
import './components/animation.css'

const root = document.getElementById('root')
const hasPrerendered = root.hasChildNodes()

const app = (
  <React.StrictMode>
    <TranslationProvider initialTranslations={en}>
      <ThemeProvider>
        <PaletteProvider>
          <TorchVideoProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
            <Analytics />
          </TorchVideoProvider>
        </PaletteProvider>
      </ThemeProvider>
    </TranslationProvider>
  </React.StrictMode>
)

if (hasPrerendered) {
  ReactDOM.hydrateRoot(root, app)
} else {
  ReactDOM.createRoot(root).render(app)
}

